<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="kt-portlet">
        <div class="kt-portlet__head">
          <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
              <i class="fal fa-file-chart-line"></i>
              Goal History Report
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div v-if="!isFetching">
            <div>
              <v-data-table
                :headers="headers"
                :items="existing_goals"
                :items-per-page="10"
                item-key="unitName"
                class="elevation-1 mt-3"
                :loading="isFetching"
              >
                <template v-slot:item.is_sent="{ item }">
                  <span>{{ item.is_sent ? 'Sent' : 'Pending' }}</span>
                </template>
                <template v-slot:item.created_at="{ item }">
                  <span>{{ item.created_at | displayDateTime }}</span>
                </template>
              </v-data-table>
            </div>
          </div>
          <div v-if="isFetching">
            <vue-content-loader
              :width="994"
              :height="554"
              :speed="2"
              primaryColor="#e4e2e2"
              secondaryColor="#ecebeb"
            >
              <rect x="0" y="0" rx="0" ry="0" width="994" height="559" />
            </vue-content-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueContentLoader from 'vue-content-loading';
export default {
  name: 'GoalHistoryReport',

  components: {
    VueContentLoader,
  },

  props: {
    userId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'Goal',
          align: 'left',
          value: 'goal',
          width: 200,
        },
        {
          text: 'Status',
          value: 'is_sent',
          align: 'center',
          width: 200,
        },
        {
          text: 'Date Created',
          value: 'created_at',
          align: 'center',
          width: 200,
        },
      ],
      isFetching: false,
      existing_goals: [],
      selectedUsers: [],
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.isFetching = true;
      const userId = this.userId;
      this.$http
        .get(`/user-goal/${userId}`)
        .then((response) => {
          this.existing_goals = response.data.data;
          this.isFetching = false;
        })
        .catch((error) => {});
    },
  },
};
</script>
